import { Panel, PanelType, Stack, mergeStyleSets } from "@fluentui/react";
import React, { useCallback, useEffect, useState } from "react";
import { PanelHeader } from "../../../components/Panel/PanelHeader";
import { PanelFooter } from "../../../components/Panel/PanelFooter";
import { MensajeBar } from "../../../components/generic/ManejoResponseMessage/MessageBar";

import IdicadorProgress from "../../../components/generic/IndicadorProgress";
import {
  IItemCheckboxBaseDTO,
  IListaRol,
  IUserById,
} from "../../../Interfaces/IUsuario";
import usuarioServicio from "../../../services/usuarioService";
import { IResponsePost } from "../../../Interfaces/base/IResponse";

interface IPanelEliminarRol {
  isOpen: boolean;
  onDismiss: () => void;
  onRenderTable: () => void;
  rol: IListaRol | null;
  identityId: string | undefined;
}
export const PanelEliminarRol = (props: IPanelEliminarRol) => {
  const [isContenedor, setIsContenedor] = useState(false);
  const [isEnviado, setIsEnviado] = useState(false);
  const [isError, setIsError] = useState(false);
  const [disableForm, setDisableForm] = useState(false);

  const [isSend, setIsSend] = useState(false);
  const [isSaccesfull, setIsSaccesfull] = useState(false);

  useEffect(() => {
    if (props.isOpen) {
      setIsSend(false);
      setIsSaccesfull(false);
      //   dataRoles();
      //   getUserById();
    }
  }, [props.isOpen]);

  const onRenderHeader = useCallback(
    () => (
      <>
        <PanelHeader
          fontSize="22px"
          nameIconHeader="Delete"
          subTextHeader={"Rol: " + props.rol?.descripcion!}
          textHeader={"Eliminar Rol"}
        />
      </>
    ),
    [props.rol]
  );
  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Eliminar Rol"
          texto2={"Salir"}
          disableButton={disableForm}
          onClick={() => {
            _confirmar();
          }}
          onDismiss={() => {
            limpiarResponse();
          }}
        />
      </>
    ),
    [disableForm, props.rol]
  );

  const _confirmar = () => {
    setIsSend(true);
    setIsContenedor(true);
    setDisableForm(true);

    usuarioServicio
      .quitarRolUser({ identityId: props.identityId!, roleId: props.rol?.key! })
      .then((res) => {
        if (res.status === 200) {
          setIsSend(false);
          setIsSaccesfull(true);
          setIsEnviado(true);
          props.onRenderTable();
        }
      })
      .catch((err: Error) => {
        console.log(err.message);
        setIsError(true);
      });
  };

  const limpiarResponse = () => {
    setIsSend(false);
    setIsSaccesfull(false);
    setIsContenedor(false);
    setIsEnviado(false);
    setIsError(false);
    setDisableForm(false);
    props.onDismiss();
  };
  return (
    <Panel
      isOpen={props.isOpen}
      onDismiss={props.onDismiss}
      onRenderHeader={onRenderHeader}
      onRenderFooter={onRenderFooter}
      type={PanelType.custom}
      customWidth="400px"
      isFooterAtBottom={true}
    >
      <>
        <br />
        {/* <pre>{JSON.stringify(props.rol, null, 2)}</pre> */}

        {isSend}
        {<IdicadorProgress subText="Registrando Datos" isSend={isSend} />}

        {isSaccesfull == true && (
          <MensajeBar
            ocultar={() => limpiarResponse()}
            response={{
              mensaje: "Se eliminó el rol " + props.rol?.descripcion,
              codigoMensaje: 1,
            }}
          />
        )}

        {isError == true && (
          <MensajeBar
            ocultar={() => limpiarResponse()}
            response={{ mensaje: "Ocurrio un problema", codigoMensaje: 2 }}
          />
        )}

        <div hidden={isContenedor}>
          <Stack>
            <Stack.Item
              grow={3}
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <h3>¿Desea eliminar el Rol {props.rol?.descripcion!} ?</h3>
              <span>Esta acción no se podrá deshacer.</span>
            </Stack.Item>
          </Stack>
        </div>
        <br />
        <br />

        {/*  <pre>{JSON.stringify(objRegistrar, null, 2)}</pre> */}
      </>
    </Panel>
  );
};
